import { BackstageInfoResponse } from '@/types/response/BackstageInfoResponse.type'
import { BackstageSession } from '@/types/BackstageSession.type'
import { Toolbar } from '@/types/Toolbar.type'
import { Broadcast } from '@/types/Event.type'

export type State = {
    backstageInfos: BackstageInfoResponse | null
    live: BackstageSession
    greenroom: BackstageSession
    broadcast: Broadcast | null
    streamInputSources: {
        video: OT.Device | null
        audio: OT.Device | null
    }
    toolbar: Toolbar
    browserAudioBlocked: boolean
}

const state: State = {
    backstageInfos: null,
    toolbar: {
        isAudioActivated: true,
        isVideoActivated: true,
    },
    live: {
        session: null,
        status: null,
        streams: [],
        connections: [],
        publishers: [],
        volume: 100,
    },
    greenroom: {
        session: null,
        status: null,
        streams: [],
        connections: [],
        publishers: [],
        volume: 0,
    },
    browserAudioBlocked: false,
    broadcast: null,
    streamInputSources: {
        video: null,
        audio: null,
    },
}

export default state
